import { isFunction } from 'lodash';
import React, { forwardRef, memo, useRef } from 'react';
import getElementBoundaries from 'utils/getElementBoundaries';
import SizeControl from './SizeControl';
const SizeControls = forwardRef(({ onResize, onResizeStop }, ref) => {
    const element = ref;
    const startWidth = useRef(null);
    const handleResize = (type, ox, oy) => ({ x, y }) => {
        if (!type)
            return;
        onResize();
        if (!startWidth.current)
            startWidth.current = getElementBoundaries(element.current);
        const { left, top, size: { width, height }, } = startWidth.current;
        if ((type === 'width' || type === 'both') && ox) {
            element.current.style.left = `${ox ? left + x : left}px`;
            element.current.style.width = `${width - x}px`;
        }
        if ((type === 'height' || type === 'both') && oy) {
            element.current.style.top = `${oy ? top + y : top}px`;
            element.current.style.height = `${height - y}px`;
        }
        if ((type === 'width' || type === 'both') && !ox)
            element.current.style.width = `${width + x}px`;
        if ((type === 'height' || type === 'both') && !oy)
            element.current.style.height = `${height + y}px`;
    };
    const handleResizeStop = () => {
        startWidth.current = null;
        if (isFunction(onResizeStop))
            onResizeStop();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(SizeControl, { className: "left top", onResize: handleResize('both', true, true), onResizeStop: handleResizeStop }),
        React.createElement(SizeControl, { className: "left center-vertical", onResize: handleResize('width', true, true), onResizeStop: handleResizeStop }),
        React.createElement(SizeControl, { className: "left bottom", onResize: handleResize('both', true, false), onResizeStop: handleResizeStop }),
        React.createElement(SizeControl, { className: "center-horizontal top", onResize: handleResize('height', true, true), onResizeStop: handleResizeStop }),
        React.createElement(SizeControl, { className: "center-horizontal bottom", onResize: handleResize('height', false, false), onResizeStop: handleResizeStop }),
        React.createElement(SizeControl, { className: "right top", onResize: handleResize('both', false, true), onResizeStop: handleResizeStop }),
        React.createElement(SizeControl, { className: "right center-vertical", onResize: handleResize('width', false, false), onResizeStop: handleResizeStop }),
        React.createElement(SizeControl, { className: "right bottom", onResize: handleResize('both', false, false), onResizeStop: handleResizeStop })));
});
export default memo(SizeControls);
